import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "components/common/checkbox";
import { Button } from "components/common/button";
import { CreatableSelect, Select } from "components/common/select";
import { currencyType, vendorType } from "custom-prop-types";
import { Field, reduxForm } from "redux-form";
import styles from "components/documents/batch-edit-form.scss";

const StatelessBatchEditForm = ({
  currencies,
  isLoading,
  onSubmitBatchEdit,
  onClose,
  reset,
  vendors
}) => (
  <form>
    <div className={ styles.section }>
      <h4>Vendor</h4>
      <div className={ styles["fields-container"] }>
        <Field
          component={ vendorFieldWrapper(mapVendors(vendors)) }
          name="vendor"
        />
      </div>
    </div>
    <div className={ styles.section }>
      <h4>Document type</h4>
      <div className={ styles["fields-container"] }>
        <Field
          component={ documentTypeFieldWrapper() }
          name="documentType"
        />
      </div>
    </div>
    <div className={ styles.section }>
      <h4>Currency</h4>
      <div className={ styles["fields-container"] }>
        <Field
          component={ currencyFieldWrapper(currencyMapper(currencies)) }
          name="currency"
        />
      </div>
    </div>
    <div className={ styles.actions }>
      <Button link onClick={ () => { reset(); onClose(); } }>cancel</Button>
      <Button loading={ isLoading } onClick={ onSubmitBatchEdit } primary>Save</Button>
    </div>
  </form>
);

StatelessBatchEditForm.propTypes = {
  currencies: PropTypes.arrayOf(currencyType).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitBatchEdit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  vendors: PropTypes.arrayOf(vendorType).isRequired
};

export const BatchEditForm = reduxForm({ form: "documentsBatchEdit" })(StatelessBatchEditForm);

const documentTypes = [
  { key: "receipt", name: "Receipt" },
  { key: "other", name: "Other" }
];

const vendorFieldWrapper = (vendors) => (props) => fieldWrapper(props, vendors, "Vendor...", true);
const documentTypeFieldWrapper = () => (props) => fieldWrapper(props, documentTypes, "Document type...");
const currencyFieldWrapper = (currencies) => (props) => fieldWrapper(props, currencies, "Currency...");

export const fieldWrapper = ({ input: { onChange, value, name } }, data, placeholder, creatable = false) => (
  <div className={ styles["fields-container__row"] }>
    <div>
      <Checkbox
        checked={ value !== null && value !== "" }
        disabled={ value === null || value === "" || value === undefined }
        onChange={ () => onChange("") }
      />
    </div>
    <div>
      { renderSelectComponent({ data, onChange, placeholder, value }, creatable)}
    </div>
  </div>
);

const renderSelectComponent = (props, isCreatable) => (
  isCreatable ? <CreatableSelect { ...props } createOption={ () => null } /> : <Select { ...props } />
);

fieldWrapper.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.object
  }).isRequired
};

const currencyMapper = (currencies) => currencies.map(currency => (
  { key: currency.code, name: currency.code }
));

const mapVendors = (vendors) => vendors.map(vendor => (
  { key: vendor.name, name: vendor.name }
));



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/forms/batch-edit-form.jsx